export default "__VITE_ASSET__b31e26f4__"